define(['jquery', 'vue', 'guid', 'clone-deep', 'api-request', 'spinner'],
    function ($, Vue, guid, cloneDeep, apiRequest, spinner) {
        Vue.component('cc-add-cart', {
            delimiters: ['@{', '}@'],
            template  : "\
                <div class='cc-add-cart-container' :class='container_name'>\
                    <div class='cart-btn' @click.stop='displayOptionSelect()'>\
                        <img :src='icon_add_cart_src' alt='장바구니 담기'>\
                    </div>\
                </div>\
            ",
            props     : {
                product_id       : {
                    type: Number
                },
                icon_add_cart_src: {
                    type: String
                },
                offset_top       : {
                    type   : Number,
                    default: -50
                },
                offset_left      : {
                    type   : Number,
                    default: -150
                },
            },
            data      : function () {
                return {
                    container_name: 'cart-product-' + guid(),
                    cart          : {variant_id: undefined, quantity: undefined}
                }
            },
            mounted   : function () {
                var self = this;
                $("body")
                    .on("click", ".cart-option-" + this.container_name + " .close-option-select-btn", this.closeOptionSelect)
                    .on("click", ".cart-option-" + this.container_name + " .add-cart-btn", function () {
                        self.cart.variant_id = $(".cart-option-" + self.container_name).find(".variant-id").val();
                        self.addCart();
                    });
            },
            methods   : {
                displayOptionSelect: function () {
                    $(".cart-product-option-select-wrap").remove();
                    var container_offset = $("." + this.container_name).offset();
                    var self = this;
                    apiRequest.get("https://cus7.cconmausa.com/api/products/" + self.product_id + "/options")
                        .then(function (response) {
                            if (response.options.length === 0)
                            {
                                self.cart.variant_id = response.variant_id;
                                self.addCart();
                            }
                            else
                            {
                                self.closeOptionSelect();
                                self.renderOptionSelectHtml(response.options, container_offset.top, container_offset.left);
                            }
                        }, alert);

                },
                // 모바일에서 장바구니 담기 옵션선택 UI가 모달로 띄어짐. body 바로 아래 렌더링을 하지 않으면 select, 버튼 클릭이 안되는 문제가 있음. 부득이하게 vue를 사용안함
                renderOptionSelectHtml: function (options, container_top, container_left) {
                    var html = "\
                    <div class='cart-product-option-select-wrap cart-option-" + this.container_name + "'>\
                          <div class='cart-product-option-select'>\
                                  <div class='title'>구성선택</div>\
                                  <select class='variant-id'>";
                    html += options.map(function (option) {
                        var is_sold_out = option.inventory_quantity <= 0;
                        return "<option value='" + option.variant_id + "'" + (is_sold_out ? 'disabled' : '') + ">" + option.title + "&nbsp;&nbsp;$" + option.price  + (is_sold_out ? '&nbsp;품절' : '') + "</option>";
                    });
                    html += "\
                                  </select>\
                                  <div class='buttons-wrap'>\
                                    <button class='btn btn-primary btn-sm add-cart-btn'>장바구니 담기</button>\
                                    <button class=\"btn close-option-select-btn\">닫기</button>\
                                  </div>\
                              <div style=\"clear:both\"></div>\
                          </div>\
                    </div>";

                    $("body").append(html);
                    $(".cart-option-" + this.container_name).css({"top": (container_top + parseInt(this.offset_top)) + 'px', "left": (container_left + parseInt(this.offset_left)) + 'px'});
                },
                addCart               : function () {
                    var self = this;
                    if (!this.cart.variant_id)
                    {
                        alert("구성을 선택해주세요.");
                        return;
                    }
                    //if (!this.cart.quantity) {
                    //   alert("수량을 입력해주세요.");
                    //   return;
                    //}
                    spinner.show({
                        img      : "//ws.cconma.com/Images/Mobile/Ccapp/Icon/loading_gray.gif",
                        size     : 46,
                        bg       : "rgba(255,255,255,0.4)",
                        box_bg   : "transparent",
                        font_size: 18,
                        color    : "black"
                    })
                        .then(function () {
                            return apiRequest.post("//www.cconmausa.com/apps/ext9api/jsapi", {
                                action     : "add_to_extcart",
                                cart_token : _cart_token,
                                customer_id: _customer_id,
                                variant_id : self.cart.variant_id,
                                quantity   : 1,//self.cart.quantity
                            });
                        })

                        .then(function (response) {
                            self.closeOptionSelect();
                            //extcart_merge.js에 포함된 함수
                            proceed_after_adding_product_to_extcart(response);

                        })
                        .then(spinner.hide);
                },
                closeOptionSelect     : function () {
                    this.cart = {variant_id: undefined, quantity: undefined};
                    $(".cart-option-" + this.container_name).remove();
                }
            }

        });
    });